import BaseModel              from '@/lib/data/model/BaseModel'
import ElectionVoterValidator from '@/api/validations/election/ElectionVoterValidator'
import ElectionVoterResource  from '@/api/resources/election/ElectionVoterResource'

export default class ElectionVoterModel extends BaseModel {
  constructor (payload = {}, resource = ElectionVoterResource, validator = ElectionVoterValidator) {
    super(payload, resource, validator)
  }

  boot () {
    super.boot()

    this.guarded = []
  }

  /* PROPERTIES */

  /* METHODS */
}
